<template>
  <tm-card-section class="tm-faq-card-section">
    <slot />
  </tm-card-section>
</template>

<script lang="ts">
import { defineComponent } from '@/composition/vue/compositionApi'
import TmCardSection from '@/components/shared/cards/TmCardSection.vue'

export default defineComponent({
  components: { TmCardSection },
})
</script>

<style lang="scss" scoped>
.tm-faq-card-section {
  padding: 0 0 8px 0;
}
</style>
